import User from "../../api/User"
import Login from "../../api/Login"
import TokenStorage from "../../utils/TokenStorage"
import TokenParser from "../../utils/TokenParser"
import router from "@/router";

const state = {
  activeAccount: null,
  isConnected: false
};

const getters = {
  getWeb2ActiveAccount(state) {
    return state.activeAccount;
  },

  isWeb2UserConnected(state) {
    return state.isConnected;
  }
};

const actions = {
  async initWeb2({ dispatch }) {
    const token = TokenStorage.get();
    if (token) {
      return await dispatch("checkTokenExpired", token);
    }
  },

  async connectAccount({ commit }, user) {
    commit("setIsConnected", true);
    commit("setActiveAccount", user);
  },

  async disconnectAccount({ commit }) {
    commit("disconnectAccount");
    commit("setIsConnected", false);
  },

  async checkTokenExpired({ commit }, token) {
    const tokenParsed = new TokenParser(token);

    if (!tokenParsed.isExpired()) {
      try {
        const response = await User.getMe();
        commit("setIsConnected", true);
        commit("setActiveAccount", response.data);
        return true;
      } catch (error) {
        console.error("Error fetching user data", error);
        return false;
      }
    } else {
      try {
        const response = await Login.renewToken();
        if (token !== response.data.token) {
          TokenStorage.set(response.data.token);
          commit("setIsConnected", true);
          commit("setActiveAccount", response.data.user);
        }
        return true;
      } catch (error) {
        console.error("Token renewal failed", error);
        commit("setIsConnected", false);
        commit("setActiveAccount", null);
        TokenStorage.remove();
        router.push("/login"); // opcional
        return false;
      }
    }
  }
};

const mutations = {
  disconnectAccount(state) {
    state.activeAccount = null;
    state.isConnected = false;
    TokenStorage.remove();
    router.push("/");
  },

  setActiveAccount(state, user) {
    state.activeAccount = user;
  },

  setIsConnected(state, isConnected) {
    state.isConnected = isConnected;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
